var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPhoneNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20275 3C3.26575 5.948 3.26575 10.729 6.20275 13.677L8.6198 16.104C11.5568 19.053 16.3168 19.053 19.2528 16.104L15.3907 12.227L14.2347 13.388C13.1677 14.459 11.4387 14.459 10.3727 13.388L8.9078 11.917C7.8408 10.847 7.8408 9.11 8.9078 8.039L10.0637 6.878L6.20275 3Z",
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPhoneNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PhoneNew.d9b90d3c.svg";
export { ForwardRef as ReactComponent };